import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { produce } from 'immer'

import { Logic } from 'core-components/types'

import { IMainState } from './models/IFilterState'

const initialState: IMainState = {
  filters: {},
}

export const filterSlice = createSlice({
  name: 'filtersContent',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<any>) => {
      state.filters = action.payload
    },
    setSavedFilters: (state, action: PayloadAction<any>) => {
      const newFilterObj = {
        logic: Logic.AND,
        filters: action.payload || [],
      }
      state.filters = newFilterObj
    },
    resetFilters: (state) => {
      return produce(state, (draftState) => {
        draftState.filters = {}
      })
    },
    resetSingleFilter: (state, action: PayloadAction<string>) => {
      return produce(state, (draftState) => {
        if (draftState.filters[action.payload]) {
          draftState.filters[action.payload].filters.splice(0)
        }
      })
    },
  },
})

export const { setFilters, setSavedFilters, resetFilters, resetSingleFilter } = filterSlice.actions

export const filterReducer = filterSlice.reducer
